import {
  ContentTypeFilterClause,
  ExplorableItemDefinition,
  MixedContentItemDefinition,
  SpaceDefinition
} from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { ContentFiltersKeys } from '../ContentFilters';
import { getNoDefaultFilters } from './getDefaultFilters';
import { CollectionCard } from '../../../app/spaces/CardView/CollectionCard';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { CollectionsResourceQuery } from '../../../app/spaces/Collections/Collections';
import { IContentInfo } from '../IContentInfo';
import { ConnectedCollectionDetailsDialogBody } from '../../../app/spaces/Collections/CollectionDetailsDialog';
import { ICollectionInfo } from '../../../app/spaces/Collections/ICollectionInfo';
import * as React from 'react';

export const CollectionDefinition: SpaceDefinition<'collection'> & ExplorableItemDefinition & MixedContentItemDefinition = {
  itemType: 'collection',
  singularName: Messages.collection,
  pluralName: Messages.collections,
  emptyStateMessage: Messages.collectionsEmptyMessage,
  contentFilterKeys: [
    // ContentFiltersKeys.search, TFSID: 1114216
    ContentFiltersKeys.owner,
    ContentFiltersKeys.updatedTimeAfter,
    ContentFiltersKeys.updatedTimeBefore,
    ContentFiltersKeys.createdTimeAfter,
    ContentFiltersKeys.createdTimeBefore,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.collectionVisibility
  ],
  defaultFilters: getNoDefaultFilters,
  cardComponent: CollectionCard,
  listViewIconUrl: imgPath('collection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['collection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return new CollectionsResourceQuery();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
  contentType: 'collection',
  fieldValueResourceType: 'collection',
  contentSpaceUrl: (urls, _contentId, luid) => urls.collectionUrl(luid),
  headerIconPath: () => undefined, // we don't want to show a header icon for collections
  detailDialogTitle: Messages.collectionsDetailsTitle,
  detaillDialogBody: (content: IContentInfo<'collection'>) => {
    return <ConnectedCollectionDetailsDialogBody collection={content as ICollectionInfo}/>;
  },
  siteFilterByTypeDropdownName: Messages.collection
};
